/** Mercados cujo CPF/celular viram obrigatórios em 27/04/2026 (comparar valor normalizado de localStorage `market`). */
const MARKETS_MANDATORY_FROM_2026_04_27 = [
  'ceara',
  'centro oeste',
  'para',
];

/** Interior SP, Sudeste — obrigatório a partir de 04/05/2026 */
const MARKETS_MANDATORY_FROM_2026_05_04 = [
  'interior sp',
  'interior de sp',
  'sudeste',
];

/** Grande SP, Bahia — obrigatório a partir de 11/05/2026 */
const MARKETS_MANDATORY_FROM_2026_05_11 = [
  'grande sp',
  'grande sao paulo',
  'bahia',
];

/** Sul — obrigatório a partir de 18/05/2026 */
const MARKETS_MANDATORY_FROM_2026_05_18 = ['sul'];

function startOfLocalDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/**
 * @param {string | null | undefined} raw
 * @returns {string}
 */
export function normalizeMarketName(raw) {
  if (raw == null || typeof raw !== 'string') return '';
  return raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ');
}

function mandatoryStartDateForNormalizedMarket(normalized) {
  if (MARKETS_MANDATORY_FROM_2026_04_27.includes(normalized)) {
    return new Date(2026, 3, 27);
  }
  if (MARKETS_MANDATORY_FROM_2026_05_04.includes(normalized)) {
    return new Date(2026, 4, 4);
  }
  if (MARKETS_MANDATORY_FROM_2026_05_11.includes(normalized)) {
    return new Date(2026, 4, 11);
  }
  if (MARKETS_MANDATORY_FROM_2026_05_18.includes(normalized)) {
    return new Date(2026, 4, 18);
  }
  return new Date(2026, 4, 18);
}

/**
 * @param {string | null | undefined} marketRaw valor de `localStorage.getItem('market')`
 */
export function isValeGasConsumerCpfPhoneRequired(marketRaw) {
  const normalized = normalizeMarketName(marketRaw);
  const start = mandatoryStartDateForNormalizedMarket(normalized);
  const today = startOfLocalDay(new Date());
  return today >= startOfLocalDay(start);
}

/**
 * Aviso exibido enquanto CPF/celular ainda são opcionais para aquele mercado. `null` quando já obrigatório.
 * @param {string | null | undefined} marketRaw
 * @returns {{ lead: string, date: string, tail: string } | null}
 */
export function getValeGasConsumerFieldsNotice(marketRaw) {
  if (isValeGasConsumerCpfPhoneRequired(marketRaw)) return null;

  const tail =
    ' será obrigatório o preenchimento dos campos telefone e CPF do cliente.';
  const normalized = normalizeMarketName(marketRaw);
  if (MARKETS_MANDATORY_FROM_2026_04_27.includes(normalized)) {
    return { lead: 'Importante! A partir do dia ', date: '27/04/2026', tail };
  }
  if (MARKETS_MANDATORY_FROM_2026_05_04.includes(normalized)) {
    return { lead: 'Importante! A partir do dia ', date: '04/05/2026', tail };
  }
  if (MARKETS_MANDATORY_FROM_2026_05_11.includes(normalized)) {
    return { lead: 'Importante! A partir do dia ', date: '11/05/2026', tail };
  }
  if (MARKETS_MANDATORY_FROM_2026_05_18.includes(normalized)) {
    return { lead: 'Importante! A partir do dia ', date: '18/05/2026', tail };
  }
  return { lead: 'Importante! A partir do dia ', date: '18/05/2026', tail };
}
